/* eslint-disable no-nested-ternary */
/* eslint-disable react/require-default-props */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Message, { MESSAGE_TYPE_MAP } from '../../../componentLibrary/Message/Message';
import * as Styled from './styles';
import ProgressBar from '../../../componentLibrary/ProgressBar/ProgressBar';
import rules from '../../../constants/businessRules/businessRules';

const SizeTracker = ({ size, onDismiss, onSizeUpdate }) => {
    const [messageType, setMessageType] = useState(MESSAGE_TYPE_MAP.WARNING);
    const [remainingData, setRemainingData] = useState(rules.GMAIL_MAX_CONTENT_SIZE);
    const [percentageData, setPercentageData] = useState(0);
    const [isOverflow, setIsOverflow] = useState(false);

    useEffect(() => {
        setRemainingData(rules.GMAIL_MAX_CONTENT_SIZE - size);
        setPercentageData((size * 100) / rules.GMAIL_MAX_CONTENT_SIZE);
        onSizeUpdate(size);
    }, [size, onSizeUpdate]);

    useEffect(() => {
        setMessageType(percentageData < 30 ? MESSAGE_TYPE_MAP.SUCCESS : (percentageData < 80 ? MESSAGE_TYPE_MAP.WARNING : MESSAGE_TYPE_MAP.ERROR));
        setIsOverflow(percentageData > 100);
    }, [percentageData]);

    const _getSizeMessage = () => {
        const absRemainingData = Math.abs(remainingData);
        return absRemainingData > 1024 ? `${Math.trunc(absRemainingData / 1024)} ` : '1 ';
    };

    return (
        <Styled.SizeTrackerContainer>
            <Message type={messageType} showIcon={isOverflow} showDismiss={false} onDismiss={onDismiss}>
                <Styled.SizeTrackerRightContainer isOverflow={isOverflow}>
                    {!isOverflow &&
                        <Styled.ProgressContainer>
                            <ProgressBar type={messageType} percentage={percentageData} />
                        </Styled.ProgressContainer>
                    }
                    <Styled.SizeTrackerText showRedText={percentageData >= 80} isOverflow={isOverflow}>
                        <b>{_getSizeMessage()}</b>
                        {isOverflow ? ' KB over Gmail limit' : ' KB remaining'}
                    </Styled.SizeTrackerText>
                </Styled.SizeTrackerRightContainer>
            </Message>
        </Styled.SizeTrackerContainer>
    );
};

SizeTracker.propTypes = {
    size: PropTypes.number,
    onDismiss: PropTypes.func,
    onSizeUpdate: PropTypes.func,
};

const mapStateToProps = (state) => ({
    size: state.htmlOutput.size,
});

export default connect(mapStateToProps)(SizeTracker);
